require(
      "!../../node_modules/gatsby-module-loader/patch.js"
    );
    module.exports = function(cb) { return require.ensure([], function(_, error) {
        if (error) {
          console.log('bundle loading error', error)
          cb(true)
        } else {
          cb(null, function() { return require("!!../../node_modules/json-loader/index.js!./blog-everything-you-need-to-start-a-modular-testable-full-stack-javascript-project.json") })
        }
      }, "path---blog-everything-you-need-to-start-a-modular-testable-full-stack-javascript-project");
     }
    


//////////////////
// WEBPACK FOOTER
// ./~/gatsby-module-loader?name=path---blog-everything-you-need-to-start-a-modular-testable-full-stack-javascript-project!./.cache/json/blog-everything-you-need-to-start-a-modular-testable-full-stack-javascript-project.json
// module id = 798
// module chunks = 231608221292675